import { destroyCookie } from 'nookies'
import type { AsyncAction } from './types'
import { createFingerprint, authLogout, resetAuthData } from './auth/user/actions'
import { createProfilingId } from './auth/user/reducer'
import { COOKIE_SHOW_NEW_PORTAL, COOKIE_SHOW_OLD_PORTAL } from '../utils/redirects'
import { clearUserFromStorage } from '../utils/userStorage'
import { clearApPortalToken } from '../utils/tokenStorage'
import { resetConsumerData } from './account/consumer/actions'
import { clearConsumer } from './account/consumer/reducer'
import { persistor } from './store'

const PERSIST_STORAGE_KEY = 'persist:portal-root'

export const initialise = (): AsyncAction<void> => async (dispatch) => {
  await dispatch(createProfilingId())
  await dispatch(createFingerprint())
}

export const clearCookie = (): void => {
  destroyCookie(null, COOKIE_SHOW_NEW_PORTAL)
  destroyCookie(null, COOKIE_SHOW_OLD_PORTAL)
}

export const clearState =
  (backToShop = true): AsyncAction<void> =>
  async (dispatch) => {
    persistor?.pause?.()

    // Clear other non-session storage data
    if (backToShop) {
      clearCookie()
    }
    clearUserFromStorage() // Clear localStorage user data
    clearApPortalToken() // Clear JWT token from localStorage

    // Reset Redux state so the next persisted snapshot is clean
    dispatch(clearConsumer())
    await dispatch(resetAuthData())
    await dispatch(resetConsumerData())

    // Final logout action for any remaining cleanup
    await dispatch(authLogout({ backToShop }))

    if (typeof window !== 'undefined' && window.sessionStorage) {
      try {
        window.sessionStorage.removeItem(PERSIST_STORAGE_KEY)
      } catch (error) {
        console.error('Failed to remove persisted Redux state during logout:', error)
      }
    }

    if (persistor != null) {
      try {
        await persistor.purge()
      } catch (error) {
        console.warn('Failed to purge persisted state during logout:', error)
      } finally {
        persistor.persist()
      }
    }
  }
